import { render, staticRenderFns } from "./goodsStatistics.vue?vue&type=template&id=54984a68&scoped=true"
import script from "./goodsStatistics.vue?vue&type=script&lang=js"
export * from "./goodsStatistics.vue?vue&type=script&lang=js"
import style0 from "./goodsStatistics.vue?vue&type=style&index=0&id=54984a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54984a68",
  null
  
)

export default component.exports